import { useEffect, useState } from 'react';

/**
 * Laddar widget-skriptet exakt en gång i SPA-miljö.
 */
export function useWidgetLoader() {
  const [loaded, setLoaded] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const widgetUrl =
    process.env.NODE_ENV === 'development'
      ? 'http://localhost:3008/widget/dist/widget.js'
      : 'https://bostad-widget.pintar.se/widget.js';

  useEffect(() => {
    if (typeof window === 'undefined') return;

    let script = document.querySelector<HTMLScriptElement>('script[data-ps-widget="bostad"]');

    const handleLoad = () => setLoaded(true);
    const handleError = () => setError('Kunde inte ladda widget.js');

    if (script) {
      if (script.dataset.loaded === 'true') {
        setLoaded(true);
      } else {
        script.addEventListener('load', handleLoad);
        script.addEventListener('error', handleError);
      }
      return;
    }

    script = document.createElement('script');
    script.async = true;
    script.src = widgetUrl;
    script.setAttribute('data-ps-widget', 'bostad');

    script.addEventListener('load', () => {
      script!.dataset.loaded = 'true';
      handleLoad();
    });
    script.addEventListener('error', handleError);

    document.head.appendChild(script);
  }, []);

  return { loaded, error };
}
